import { DailyRollupModelBase }       from '../../timecard/DailyRollupModel';
import timecardTestEditTimecardsModel from './TimecardTestEditTimecardsModel';
import { timecardTestRouteManager }   from '../../main-navigation/RouteManager';
import { TimecardModelBase }          from '../../timecard/TimecardModel';

class TimecardTestEditTimecardsDailyRollupModel extends DailyRollupModelBase {
  constructor() {
    super();

    this.DYNAMIC_COLUMN_STARTING_POSITION = 10;
  }

  get timecardModel(): TimecardModelBase {
    return timecardTestEditTimecardsModel;
  }

  get isLoading(): boolean {
    return this.state.isLoading || timecardTestRouteManager.isLoading;
  }

  protected get columns(): any[] {
    const columns = super.columns;
    columns.splice(0, 2);
    return columns;
  }
}

const timecardTestEditTimecardsDailyRollupModel = new TimecardTestEditTimecardsDailyRollupModel();
export default timecardTestEditTimecardsDailyRollupModel;
